module.exports = __webpack_public_path__ + "static/media/allergen_crustacena.c0f1e8de.c0f1e8de.png";